import { render } from "./RegenerateApiKeyBtn.vue?vue&type=template&id=21bf170e&ts=true"
import script from "./RegenerateApiKeyBtn.vue?vue&type=script&lang=ts"
export * from "./RegenerateApiKeyBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__